import React from "react";
import ReworkProductForm from "../../../components/user/reworkProduct/reworkProductForm";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const NewOrderPage = () => {
  let { uuid } = useParams();
  return (
    <Layout
      body={
        <>
          <ReworkProductForm uuid={uuid} />
        </>
      }
    />
  );
};

NewOrderPage.propTypes = {};

export default NewOrderPage;
